// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-table-custom .mono {
    font-family: monospace;
}


.data-table-custom>thead tr th {
    margin-bottom: 0px;  
    font-size: 0.8rem;
    vertical-align: top !important;
    font-weight: 400;
    padding: 0rem 0.4rem !important;
    border-width: 0 !important;border-right: 1px solid #383838;
}

.data-table-custom>thead tr:nth-child(even) {
    background: #E0DFDF;
}

.data-table-custom>:not(:first-child) {
  border-top: 0px solid currentColor !important;
}


.data-table-custom>:not(:first-child) {
  border-top: 0px solid currentColor !important;
}

.data-table-custom.thead.tr {
  border-bottom: 2px solid currentColor !important;
}

.data-table-custom>thead>tr.table-dark>th {
    padding: 3px 8px;
}
.data-table-custom>tbody tr.odd {
    background: #fff;
}
.ata-table-custom>tbody>tr:hover>td {
  color: #1aa6e7 !important;
}

.data-table-custom>tbody tr.even {
    /*background: #E0DFDF;*/
}
.data-table-custom>tbody.ow-datatable-tbody-scroll{
    overflow-y: scroll;
position: initial;
width: -moz-available;
height: calc(100vh - 100%);
min-height: calc(100vh - 290px);
}


.ow-datatable-gateway-id {
  text-transform: uppercase;
}

.nowarp {
    white-space: nowrap;
}

.data-table-custom>tbody tr {
    color: #333;
}

.data-table-custom>tbody tr td {
  
  border-right: 1px solid #e6e4e4;
    font-size: 0.8rem;
    padding:0px 5px;

}
.data-table-custom>tbody tr td{    
/*font-family: 'Roboto', sans-serif;*/
background-color: #fff;
}


.data-table-custom > tbody > tr > td  table > tbody > tr > td{
  border-bottom: 1px solid #e6e4e4 !important;
  }
  .data-table-custom > tbody > tr > td  table > tbody > tr > td:last-child{
  border-right: none !important;
  }

  .data-table-custom > tbody > tr > td  table > tbody > tr:last-child > td{  
    border-bottom: none !important;
  }
.data-table-custom>tbody>tr>td, .data-table-custom>tbody>tr>th, .data-table-custom>tfoot>tr>td, .data-table-custom>tfoot>tr>th, .data-table-custom>thead>tr>td, .data-table-custom>thead>tr>th {
    line-height: 1.42857143; 
    /* vertical-align: top; */
   /* border-top: 1px solid #ddd;*/
   /* background-color: #fff !important; */
     padding: 0.2rem 0.4rem;  
    vertical-align: middle; 
    /* border-radius: 10px 10px 0px 0px; */
}


.mr-0-only {
    margin-right: 0px !important;
}

.detail-link {
    text-align: left;
    font: normal normal normal 14px/17px Proxima Nova;
    letter-spacing: 0px;
    color: #076d9f;
opacity: 1;
font-weight: 700;
cursor: pointer;
background: #D1F3FF 0% 0% no-repeat padding-box;
border: 1px solid #A3E7FF;
padding: 2px;
border-radius: .2rem;
}

.table-footer{ 
  /*  position: fixed;
   bottom: 0px;
   width: -moz-available;*/
   background-color: #fff;
   border-top: 1px solid #ccc;  

   
}
/*.data-table-custom{
    display: grid !important;
}*/

/* th.last_reception{
    min-width: 300px;
} */

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
   
    opacity: 1; /* Firefox */
  }

  
  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color:#d4d4d4 !important; 
  }
  
  ::-ms-input-placeholder { /* Microsoft Edge */
    color:#d4d4d4 !important; 
  }
  input::-webkit-input-placeholder {
    color:#d4d4d4 !important; 
}
/* style written to make table body scrollable
.table > thead {
    position: sticky;
    overflow: auto;
    width: -moz-available;
  }
  .table > thead >tr {
  display: block;
  width: 100%;
}
  .table > tbody {  
    display: block;
    overflow-y: scroll;
    position: initial;
    height: calc(100vh - 270px) !important;
  }
  .table > tbody tr {
 
    width: auto;
    table-layout: fixed;
  }*/

  /* .TableScrollbar > table{
    margin-top: -2px;
  }
  .font-monospace {
    font-size: 13px;
} */

.dropdown-menu{
  padding: 0rem 0 !important;
  border: 1px solid #ccc !important;
}

.data-table-custom thead tr th .css-b62m3t-container .css-1s2u09g-control, 
.data-table-custom thead tr th .css-b62m3t-container .css-1pahdxg-control{
  min-height: 26px;
}

.data-table-custom thead tr th .css-b62m3t-container .css-1s2u09g-control .css-319lph-ValueContainer{  
  padding: 0px 8px;
}


.data-table-custom thead tr th .css-b62m3t-container .css-1s2u09g-control .css-319lph-ValueContainer .css-6j8wv5-Input {
  margin: 0px 2px;
    
    padding-bottom: 0px;
    padding-top: 0px;
}
.data-table-custom thead tr th .css-b62m3t-container .css-1pahdxg-control .css-319lph-ValueContainer .css-6j8wv5-Input{
  margin: 2px;
    
    padding-bottom: 0px;
    padding-top: 0px;
}

.data-table-custom thead tr th .css-b62m3t-container .css-1s2u09g-control .css-1hb7zxy-IndicatorsContainer{  
  min-height: calc(1.3em + .5rem + 2px);
}

.data-table-custom thead tr th .css-b62m3t-container .css-1s2u09g-control .css-1hb7zxy-IndicatorsContainer .css-1okebmr-indicatorSeparator {
  margin-bottom: 0px;  
   margin-top: 0px;
}

.data-table-custom thead tr th .css-b62m3t-container .css-1s2u09g-control .css-1hb7zxy-IndicatorsContainer .css-tlfecz-indicatorContainer,  
.data-table-custom thead tr th .css-b62m3t-container .css-1pahdxg-control .css-1hb7zxy-IndicatorsContainer .css-1gtu0rj-indicatorContainer{
  
  padding: 2px 8px !important;
}

.data-table-custom thead tr th .css-b62m3t-container .css-26l3qy-menu{
  display: flex;
  min-width: 250px; 
  margin-top: 15px;
  width: 100%; 
}

.data-table-custom thead tr th .css-b62m3t-container .css-26l3qy-menu .css-4ljt47-MenuList{
  z-index: 1099;  
  width: 100%;
  position: relative;
}

.data-table-custom thead tr th .css-b62m3t-container .css-26l3qy-menu .css-4ljt47-MenuList .css-1n7v3ny-option{
padding: 2px auto;
}
.tableHeader {
  position: sticky;
  top:0;
}


.bounce {
  outline: 0;
  border-color: red;
  animation-name: bounce;
  animation-duration: .5s;
  animation-delay: 0.25s;
}


/* This approximates the ease-in-out-bounce animation from easings.net, which would require a plug-in to use*/
@keyframes bounce {
  0% {
    transform: translateX(0px);
    timing-function: ease-in;
  }
  37% {
    transform: translateX(5px);
    timing-function: ease-out;
  }
  55% {
    transform: translateX(-5px);
    timing-function: ease-in;
  }
  73% {
    transform: translateX(4px);
    timing-function: ease-out;
  }
  82% {
    transform: translateX(-4px);
    timing-function: ease-in;
  }
  91% {
    transform: translateX(2px);
    timing-function: ease-out;
  }
  96% {
    transform: translateX(-2px);
    timing-function: ease-in;
  }
  100% {
    transform: translateX(0px);
    timing-function: ease-in;
  }
}


.debug-value {
  position:absolute;
  display:none;
  vertical-align:super;
  font-size: 10px;  
  z-index: 90;
  white-space:no-wrap;
  /* height:0px;
  width:0px; */
}


#all-extra-debug-value {
  bottom:-50px;
  right:0px;
  overflow: auto;
  border:1px solid;
  height: 100px;
}


.pagination .page-item {
    width:40px !important;
    text-align: center;
}


.pagination-wrapper {
  min-width:320px;
}

  
.map-pagination-wrapper {
  min-width:245px !important;

}

.thead-tr-class {
  max-height: 50px !important;
  border-bottom:2px solid;
}

.thead-tr-class .css-b62m3t-container {
  position: inherit !important;
}

@media only screen and (max-width: 768px) {
  .pagination-wrapper {
    min-width:200px;
  }
}
.ow-datatable-nst-gateway-tags-tagName .ow-nst-gateway-tag-color{
  background-color: #efefef;
padding: 0px 10px;
border-radius: 4px;
border: 1px dashed  #ccc; 
}


.no-link {
  text-decoration:none;
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
}

.modal-body-mobile .rdrDateRangePickerWrapper {
  display: block !important;
}

.modal-body-mobile .rdrDateRangePickerWrapper .rdrDefinedRangesWrapper {
display: flex !important;
width: 100% !important;
}

.ow-datatable-more-action-dropdown .dropdown-toggle:after {
  display: none !important;
}


.ow-datatable-overflow-ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;
}
.ow-datatable-remove-ellipsis {
  word-wrap: break-word;
  white-space: normal;
  max-width: 100%;
}

.connection-status{
  margin-top: -10px;
  color: #fff !important;
  padding: 1px 4px;
  font-size: 0.6rem !important;
  border-radius: 3px;
}
.connection-status.green {
  background-color: #17C653 !important;
  color: #fff !important;
}

.connection-status.red {
  background-color: #F8285A !important;
  color: #fff !important;
}

.green {
  background-color: #DFFFEA !important;
  color: #17C653 !important;
  border: none !important;
  font-size: 0.6rem !important;
}

.badge.green a {
  color: #17C653 !important;
}

.yellow {
  background-color: #FFF8DD !important;
  color: #F6C000 !important;
  border: none !important;
  font-size: 0.6rem !important;
}

.orange {
  background-color: #FFE6CC !important; /* Light orange background */
  color: #FF8C00 !important; /* Darker orange text */
  border: none !important;
  font-size: 0.6rem !important;
}

.badge.yellow a {
  color: #F6C000 !important;
}

.blue {
  background-color: #E9F3FF !important;
  color: #1B84FF !important;
  border: none !important;
  font-size: 0.6rem !important;
}
.badge.blue a {
  color: #1B84FF !important;
}

.pink {
  background-color: #FFEEF3 !important;
  color: #F8285A !important;
  border: none !important;  
  font-size: 0.6rem !important;
}
.badge.pink a {
  color: #F8285A !important;
}



.gray {
  background-color: #E0E0E0 !important;
  color: #606060 !important;
  border: none !important;  
  font-size: 0.6rem !important;
}
.badge.gray a {
  color: #606060 !important;
}
`, "",{"version":3,"sources":["webpack://./app_react/src/components/Common/DataTable.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,8BAA8B;IAC9B,gBAAgB;IAChB,+BAA+B;IAC/B,0BAA0B,CAAC,+BAA+B;AAC9D;;AAEA;IACI,mBAAmB;AACvB;;AAEA;EACE,6CAA6C;AAC/C;;;AAGA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gDAAgD;AAClD;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB,iBAAiB;AACjB,qBAAqB;AACrB,0BAA0B;AAC1B,+BAA+B;AAC/B;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;;EAEE,+BAA+B;IAC7B,iBAAiB;IACjB,eAAe;;AAEnB;AACA;AACA,qCAAqC;AACrC,sBAAsB;AACtB;;;AAGA;EACE,2CAA2C;EAC3C;EACA;EACA,6BAA6B;EAC7B;;EAEA;IACE,8BAA8B;EAChC;AACF;IACI,uBAAuB;IACvB,yBAAyB;GAC1B,+BAA+B;GAC/B,uCAAuC;KACrC,sBAAsB;IACvB,sBAAsB;IACtB,sCAAsC;AAC1C;;;AAGA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,iDAAiD;IACjD,mBAAmB;IACnB,cAAc;AAClB,UAAU;AACV,gBAAgB;AAChB,eAAe;AACf,+CAA+C;AAC/C,yBAAyB;AACzB,YAAY;AACZ,oBAAoB;AACpB;;AAEA;EACE;;0BAEwB;GACvB,sBAAsB;GACtB,0BAA0B;;;AAG7B;AACA;;EAEE;;AAEF;;GAEG;;AAEH,gBAAgB,yCAAyC;;IAErD,UAAU,EAAE,YAAY;EAC1B;;;EAGA,yBAAyB,4BAA4B;IACnD,wBAAwB;EAC1B;;EAEA,0BAA0B,mBAAmB;IAC3C,wBAAwB;EAC1B;EACA;IACE,wBAAwB;AAC5B;AACA;;;;;;;;;;;;;;;;;;;;IAoBI;;EAEF;;;;;GAKC;;AAEH;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,eAAe;;IAEb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;EACE,WAAW;;IAET,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;GACjB,eAAe;AAClB;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;AACA,iBAAiB;AACjB;AACA;EACE,gBAAgB;EAChB,KAAK;AACP;;;AAGA;EACE,UAAU;EACV,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;AACxB;;;AAGA,6GAA6G;AAC7G;EACE;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;EACA;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;EACA;IACE,2BAA2B;IAC3B,wBAAwB;EAC1B;EACA;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;EACA;IACE,2BAA2B;IAC3B,wBAAwB;EAC1B;EACA;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;EACA;IACE,2BAA2B;IAC3B,wBAAwB;EAC1B;EACA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;AACF;;;AAGA;EACE,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB;cACY;AACd;;;AAGA;EACE,YAAY;EACZ,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;;AAGA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;;AAGA;EACE,eAAe;AACjB;;;AAGA;EACE,0BAA0B;;AAE5B;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;AAC3B,iBAAiB;AACjB,kBAAkB;AAClB,wBAAwB;AACxB;;;AAGA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;AACA,wBAAwB;AACxB,sBAAsB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC,EAAE,4BAA4B;EAClE,yBAAyB,EAAE,uBAAuB;EAClD,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;;;;AAIA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B","sourcesContent":[".data-table-custom .mono {\n    font-family: monospace;\n}\n\n\n.data-table-custom>thead tr th {\n    margin-bottom: 0px;  \n    font-size: 0.8rem;\n    vertical-align: top !important;\n    font-weight: 400;\n    padding: 0rem 0.4rem !important;\n    border-width: 0 !important;border-right: 1px solid #383838;\n}\n\n.data-table-custom>thead tr:nth-child(even) {\n    background: #E0DFDF;\n}\n\n.data-table-custom>:not(:first-child) {\n  border-top: 0px solid currentColor !important;\n}\n\n\n.data-table-custom>:not(:first-child) {\n  border-top: 0px solid currentColor !important;\n}\n\n.data-table-custom.thead.tr {\n  border-bottom: 2px solid currentColor !important;\n}\n\n.data-table-custom>thead>tr.table-dark>th {\n    padding: 3px 8px;\n}\n.data-table-custom>tbody tr.odd {\n    background: #fff;\n}\n.ata-table-custom>tbody>tr:hover>td {\n  color: #1aa6e7 !important;\n}\n\n.data-table-custom>tbody tr.even {\n    /*background: #E0DFDF;*/\n}\n.data-table-custom>tbody.ow-datatable-tbody-scroll{\n    overflow-y: scroll;\nposition: initial;\nwidth: -moz-available;\nheight: calc(100vh - 100%);\nmin-height: calc(100vh - 290px);\n}\n\n\n.ow-datatable-gateway-id {\n  text-transform: uppercase;\n}\n\n.nowarp {\n    white-space: nowrap;\n}\n\n.data-table-custom>tbody tr {\n    color: #333;\n}\n\n.data-table-custom>tbody tr td {\n  \n  border-right: 1px solid #e6e4e4;\n    font-size: 0.8rem;\n    padding:0px 5px;\n\n}\n.data-table-custom>tbody tr td{    \n/*font-family: 'Roboto', sans-serif;*/\nbackground-color: #fff;\n}\n\n\n.data-table-custom > tbody > tr > td  table > tbody > tr > td{\n  border-bottom: 1px solid #e6e4e4 !important;\n  }\n  .data-table-custom > tbody > tr > td  table > tbody > tr > td:last-child{\n  border-right: none !important;\n  }\n\n  .data-table-custom > tbody > tr > td  table > tbody > tr:last-child > td{  \n    border-bottom: none !important;\n  }\n.data-table-custom>tbody>tr>td, .data-table-custom>tbody>tr>th, .data-table-custom>tfoot>tr>td, .data-table-custom>tfoot>tr>th, .data-table-custom>thead>tr>td, .data-table-custom>thead>tr>th {\n    line-height: 1.42857143; \n    /* vertical-align: top; */\n   /* border-top: 1px solid #ddd;*/\n   /* background-color: #fff !important; */\n     padding: 0.2rem 0.4rem;  \n    vertical-align: middle; \n    /* border-radius: 10px 10px 0px 0px; */\n}\n\n\n.mr-0-only {\n    margin-right: 0px !important;\n}\n\n.detail-link {\n    text-align: left;\n    font: normal normal normal 14px/17px Proxima Nova;\n    letter-spacing: 0px;\n    color: #076d9f;\nopacity: 1;\nfont-weight: 700;\ncursor: pointer;\nbackground: #D1F3FF 0% 0% no-repeat padding-box;\nborder: 1px solid #A3E7FF;\npadding: 2px;\nborder-radius: .2rem;\n}\n\n.table-footer{ \n  /*  position: fixed;\n   bottom: 0px;\n   width: -moz-available;*/\n   background-color: #fff;\n   border-top: 1px solid #ccc;  \n\n   \n}\n/*.data-table-custom{\n    display: grid !important;\n}*/\n\n/* th.last_reception{\n    min-width: 300px;\n} */\n\n::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */\n   \n    opacity: 1; /* Firefox */\n  }\n\n  \n  :-ms-input-placeholder { /* Internet Explorer 10-11 */\n    color:#d4d4d4 !important; \n  }\n  \n  ::-ms-input-placeholder { /* Microsoft Edge */\n    color:#d4d4d4 !important; \n  }\n  input::-webkit-input-placeholder {\n    color:#d4d4d4 !important; \n}\n/* style written to make table body scrollable\n.table > thead {\n    position: sticky;\n    overflow: auto;\n    width: -moz-available;\n  }\n  .table > thead >tr {\n  display: block;\n  width: 100%;\n}\n  .table > tbody {  \n    display: block;\n    overflow-y: scroll;\n    position: initial;\n    height: calc(100vh - 270px) !important;\n  }\n  .table > tbody tr {\n \n    width: auto;\n    table-layout: fixed;\n  }*/\n\n  /* .TableScrollbar > table{\n    margin-top: -2px;\n  }\n  .font-monospace {\n    font-size: 13px;\n} */\n\n.dropdown-menu{\n  padding: 0rem 0 !important;\n  border: 1px solid #ccc !important;\n}\n\n.data-table-custom thead tr th .css-b62m3t-container .css-1s2u09g-control, \n.data-table-custom thead tr th .css-b62m3t-container .css-1pahdxg-control{\n  min-height: 26px;\n}\n\n.data-table-custom thead tr th .css-b62m3t-container .css-1s2u09g-control .css-319lph-ValueContainer{  \n  padding: 0px 8px;\n}\n\n\n.data-table-custom thead tr th .css-b62m3t-container .css-1s2u09g-control .css-319lph-ValueContainer .css-6j8wv5-Input {\n  margin: 0px 2px;\n    \n    padding-bottom: 0px;\n    padding-top: 0px;\n}\n.data-table-custom thead tr th .css-b62m3t-container .css-1pahdxg-control .css-319lph-ValueContainer .css-6j8wv5-Input{\n  margin: 2px;\n    \n    padding-bottom: 0px;\n    padding-top: 0px;\n}\n\n.data-table-custom thead tr th .css-b62m3t-container .css-1s2u09g-control .css-1hb7zxy-IndicatorsContainer{  \n  min-height: calc(1.3em + .5rem + 2px);\n}\n\n.data-table-custom thead tr th .css-b62m3t-container .css-1s2u09g-control .css-1hb7zxy-IndicatorsContainer .css-1okebmr-indicatorSeparator {\n  margin-bottom: 0px;  \n   margin-top: 0px;\n}\n\n.data-table-custom thead tr th .css-b62m3t-container .css-1s2u09g-control .css-1hb7zxy-IndicatorsContainer .css-tlfecz-indicatorContainer,  \n.data-table-custom thead tr th .css-b62m3t-container .css-1pahdxg-control .css-1hb7zxy-IndicatorsContainer .css-1gtu0rj-indicatorContainer{\n  \n  padding: 2px 8px !important;\n}\n\n.data-table-custom thead tr th .css-b62m3t-container .css-26l3qy-menu{\n  display: flex;\n  min-width: 250px; \n  margin-top: 15px;\n  width: 100%; \n}\n\n.data-table-custom thead tr th .css-b62m3t-container .css-26l3qy-menu .css-4ljt47-MenuList{\n  z-index: 1099;  \n  width: 100%;\n  position: relative;\n}\n\n.data-table-custom thead tr th .css-b62m3t-container .css-26l3qy-menu .css-4ljt47-MenuList .css-1n7v3ny-option{\npadding: 2px auto;\n}\n.tableHeader {\n  position: sticky;\n  top:0;\n}\n\n\n.bounce {\n  outline: 0;\n  border-color: red;\n  animation-name: bounce;\n  animation-duration: .5s;\n  animation-delay: 0.25s;\n}\n\n\n/* This approximates the ease-in-out-bounce animation from easings.net, which would require a plug-in to use*/\n@keyframes bounce {\n  0% {\n    transform: translateX(0px);\n    timing-function: ease-in;\n  }\n  37% {\n    transform: translateX(5px);\n    timing-function: ease-out;\n  }\n  55% {\n    transform: translateX(-5px);\n    timing-function: ease-in;\n  }\n  73% {\n    transform: translateX(4px);\n    timing-function: ease-out;\n  }\n  82% {\n    transform: translateX(-4px);\n    timing-function: ease-in;\n  }\n  91% {\n    transform: translateX(2px);\n    timing-function: ease-out;\n  }\n  96% {\n    transform: translateX(-2px);\n    timing-function: ease-in;\n  }\n  100% {\n    transform: translateX(0px);\n    timing-function: ease-in;\n  }\n}\n\n\n.debug-value {\n  position:absolute;\n  display:none;\n  vertical-align:super;\n  font-size: 10px;  \n  z-index: 90;\n  white-space:no-wrap;\n  /* height:0px;\n  width:0px; */\n}\n\n\n#all-extra-debug-value {\n  bottom:-50px;\n  right:0px;\n  overflow: auto;\n  border:1px solid;\n  height: 100px;\n}\n\n\n.pagination .page-item {\n    width:40px !important;\n    text-align: center;\n}\n\n\n.pagination-wrapper {\n  min-width:320px;\n}\n\n  \n.map-pagination-wrapper {\n  min-width:245px !important;\n\n}\n\n.thead-tr-class {\n  max-height: 50px !important;\n  border-bottom:2px solid;\n}\n\n.thead-tr-class .css-b62m3t-container {\n  position: inherit !important;\n}\n\n@media only screen and (max-width: 768px) {\n  .pagination-wrapper {\n    min-width:200px;\n  }\n}\n.ow-datatable-nst-gateway-tags-tagName .ow-nst-gateway-tag-color{\n  background-color: #efefef;\npadding: 0px 10px;\nborder-radius: 4px;\nborder: 1px dashed  #ccc; \n}\n\n\n.no-link {\n  text-decoration:none;\n}\n.table .thead-light th {\n  color: #495057;\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n}\n\n.modal-body-mobile .rdrDateRangePickerWrapper {\n  display: block !important;\n}\n\n.modal-body-mobile .rdrDateRangePickerWrapper .rdrDefinedRangesWrapper {\ndisplay: flex !important;\nwidth: 100% !important;\n}\n\n.ow-datatable-more-action-dropdown .dropdown-toggle:after {\n  display: none !important;\n}\n\n\n.ow-datatable-overflow-ellipsis {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  max-width: 100%;\n}\n.ow-datatable-remove-ellipsis {\n  word-wrap: break-word;\n  white-space: normal;\n  max-width: 100%;\n}\n\n.connection-status{\n  margin-top: -10px;\n  color: #fff !important;\n  padding: 1px 4px;\n  font-size: 0.6rem !important;\n  border-radius: 3px;\n}\n.connection-status.green {\n  background-color: #17C653 !important;\n  color: #fff !important;\n}\n\n.connection-status.red {\n  background-color: #F8285A !important;\n  color: #fff !important;\n}\n\n.green {\n  background-color: #DFFFEA !important;\n  color: #17C653 !important;\n  border: none !important;\n  font-size: 0.6rem !important;\n}\n\n.badge.green a {\n  color: #17C653 !important;\n}\n\n.yellow {\n  background-color: #FFF8DD !important;\n  color: #F6C000 !important;\n  border: none !important;\n  font-size: 0.6rem !important;\n}\n\n.orange {\n  background-color: #FFE6CC !important; /* Light orange background */\n  color: #FF8C00 !important; /* Darker orange text */\n  border: none !important;\n  font-size: 0.6rem !important;\n}\n\n.badge.yellow a {\n  color: #F6C000 !important;\n}\n\n.blue {\n  background-color: #E9F3FF !important;\n  color: #1B84FF !important;\n  border: none !important;\n  font-size: 0.6rem !important;\n}\n.badge.blue a {\n  color: #1B84FF !important;\n}\n\n.pink {\n  background-color: #FFEEF3 !important;\n  color: #F8285A !important;\n  border: none !important;  \n  font-size: 0.6rem !important;\n}\n.badge.pink a {\n  color: #F8285A !important;\n}\n\n\n\n.gray {\n  background-color: #E0E0E0 !important;\n  color: #606060 !important;\n  border: none !important;  \n  font-size: 0.6rem !important;\n}\n.badge.gray a {\n  color: #606060 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
